export enum Padding {
  sm = '16px',
  default = '24px',
  md = '32px',
  lg = '40px',
  xl = '48px',
  xxl = '56px',
  xxxl = '64px',
}
